import * as React from "react"
import styled from "@digits-css"
import { type ButtonSize } from "@digits-shared/DesignSystem/Button"
import { CenteredLoader } from "@digits-shared/DesignSystem/CenteredLoader"
import "./ButtonContent.digits.css"

const Crib = styled.div({ cls: "ButtonContent__Crib_1eca47b" })

const ButtonLoader = styled(CenteredLoader)({ cls: "ButtonContent__ButtonLoader_2e96807" })
/**
 * Renders a centered loading animation if loading is true, otherwise renders children.
 *
 * Wrap your regular button text / icons in this component inside of a DigitsButton.
 *
 */
export const ButtonContent: React.FC<
  React.PropsWithChildren<{ loading: boolean; size: ButtonSize }>
> = ({ loading, size, children }) =>
  loading ? (
    <>
      <ButtonLoader size={size} />
      <Crib aria-hidden>{children}</Crib>
    </>
  ) : (
    children
  )
